var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcConfirmSuperBigCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 74,
    height: 74,
    rx: 37,
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 74,
    height: 74,
    rx: 37,
    fill: "url(#paint0_linear)",
    fillOpacity: 0.05
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.6654 33.666V26.9993C57.6654 25.1493 56.1654 23.666 54.332 23.666H27.6654C25.832 23.666 24.3487 25.1493 24.3487 26.9993V33.666C26.182 33.666 27.6654 35.166 27.6654 36.9993C27.6654 38.8327 26.182 40.3327 24.332 40.3327V46.9993C24.332 48.8327 25.832 50.3327 27.6654 50.3327H54.332C56.1654 50.3327 57.6654 48.8327 57.6654 46.9993V40.3327C55.832 40.3327 54.332 38.8327 54.332 36.9993C54.332 35.166 55.832 33.666 57.6654 33.666ZM54.332 31.2327C52.3487 32.3827 50.9987 34.5493 50.9987 36.9993C50.9987 39.4493 52.3487 41.616 54.332 42.766V46.9993H27.6654V42.766C29.6487 41.616 30.9987 39.4493 30.9987 36.9993C30.9987 34.5327 29.6654 32.3827 27.682 31.2327L27.6654 26.9993H54.332V31.2327ZM39.332 41.9993H42.6654V45.3327H39.332V41.9993ZM39.332 35.3327H42.6654V38.666H39.332V35.3327ZM39.332 28.666H42.6654V31.9993H39.332V28.666Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 41,
    y1: 0,
    x2: 41,
    y2: 74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcConfirmSuperBigCircle);
export default __webpack_public_path__ + "static/media/ic_confirm_super_big_circle.5a6aa6dbbe10e78ed2333505856ad4ca.svg";
export { ForwardRef as ReactComponent };